import React from 'react';
import Head from 'next/head';
import env from '../../env';

// This needs to be on top of the page for triggers to work
// https://help.hotjar.com/hc/en-us/articles/115015712548-How-to-Use-JavaScript-Triggers-to-Start-Recordings

const Hotjar = () => (
    <script
        dangerouslySetInnerHTML={{
            __html: `
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:672997,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};
    `,
        }}
    />
);

const BaseHtmlHeader = () => (
    <Head>
        <title>SVT Play</title>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
        <meta name="format-detection" content="telephone=no" />
        <meta name="theme-color" content="#000000" />

        <meta property="fb:app_id" content={env.FB_APP_ID} />
        <meta property="fb:pages" content={env.FB_PAGES_ID} />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-2.0.0/fonts/PublikWeb-DisplayItalic.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Light.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Regular.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Bold.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href={`${
                process.env.ASSET_PREFIX || 'https://www.svtstatic.se/play/play7'
            }/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.8fab452bcc82bb309c7a0400655d05f7.woff`}
        />
        <meta name="application-name" content="SVT Play" />
        <link type="text/plain" rel="author" href="/humans.txt"></link>
        {env.FLAG_ENABLE_HOTJAR && <Hotjar />}
    </Head>
);

export default BaseHtmlHeader;
